import { render, staticRenderFns } from "./FadeTransition.vue?vue&type=template&id=39f4afd3&scoped=true"
import script from "./FadeTransition.vue?vue&type=script&lang=js"
export * from "./FadeTransition.vue?vue&type=script&lang=js"
import style0 from "./FadeTransition.vue?vue&type=style&index=0&id=39f4afd3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f4afd3",
  null
  
)

export default component.exports